module.exports = "/img/story-1-m.c19d2b26.png";